var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-1"},[_c('v-skeleton-loader',{ref:"skeleton",staticClass:"mx-auto",attrs:{"boilerplate":false,"type":"article, list-item-avatar-three-line","tile":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }